import React, { useRef, useEffect } from "react";

const SchemaFormChangeHandlerView = ({ onChange, values }) => {

  const previous = useRef({});

  useEffect(() => {
    if (!onChange) return;
    if (JSON.stringify(previous.current) !== JSON.stringify(values) && Object.keys(values).length > 0) {
      previous.current = values;
      onChange(values);
    }
  }, [values]);

  return null;
};


export default SchemaFormChangeHandlerView;